import {profGral} from 'constants/url';
import axios from 'axios';

async function getProfGralById(token, id) {
  try {
    const response = await axios.get(`${profGral}/${id}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

export default getProfGralById;
